var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiskette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3542_61787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4356 3.18938L10.8106 0.564382C10.7697 0.523834 10.7213 0.491754 10.668 0.469982C10.6147 0.44821 10.5576 0.437174 10.5 0.437507H9.625V3.93751C9.625 4.16957 9.53281 4.39213 9.36872 4.55623C9.20462 4.72032 8.98206 4.81251 8.75 4.81251H5.25C5.01794 4.81251 4.79538 4.72032 4.63128 4.55623C4.46719 4.39213 4.375 4.16957 4.375 3.93751V0.437507H1.75C1.4019 0.437507 1.06806 0.575788 0.821922 0.82193C0.575781 1.06807 0.4375 1.40191 0.4375 1.75001V12.25C0.4375 12.5981 0.575781 12.9319 0.821922 13.1781C1.06806 13.4242 1.4019 13.5625 1.75 13.5625H2.625V9.62501C2.625 9.27691 2.76328 8.94307 3.00942 8.69693C3.25556 8.45079 3.5894 8.31251 3.9375 8.31251H10.0625C10.4106 8.31251 10.7444 8.45079 10.9906 8.69693C11.2367 8.94307 11.375 9.27691 11.375 9.62501V13.5625H12.25C12.5981 13.5625 12.9319 13.4242 13.1781 13.1781C13.4242 12.9319 13.5625 12.5981 13.5625 12.25V3.50001C13.5628 3.44243 13.5518 3.38535 13.53 3.33205C13.5083 3.27874 13.4762 3.23026 13.4356 3.18938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0.4375H8.75V3.9375H5.25V0.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 9.1875H3.9375C3.82147 9.1875 3.71019 9.23359 3.62814 9.31564C3.54609 9.39769 3.5 9.50897 3.5 9.625V13.5625H10.5V9.625C10.5 9.50897 10.4539 9.39769 10.3719 9.31564C10.2898 9.23359 10.1785 9.1875 10.0625 9.1875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3542_61787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskette);
export default __webpack_public_path__ + "static/media/diskette.283e0b8f6ee01977d0f7d412acff9bce.svg";
export { ForwardRef as ReactComponent };